import { Col, Row } from 'antd';
import Card from 'antd/lib/card';
import Form from 'antd/lib/form';
import Spin from 'antd/lib/spin';
import { API_LOGIN_CONFIGURATION_ROUTE } from 'config/api-consts';
import { generalLanguageKeys } from 'config/consts';
import { crudService, routerService } from 'core/services';
import { formService } from 'core/services/FormService';
import { LoginConfiguration } from 'models/LoginConfiguration';
import React from 'react';
import { useTranslation } from 'react-i18next';
import nameof from 'ts-nameof.macro';
import { loginConfigurationRepository } from '../LoginConfigurationRepository';
import './LoginConfigurationDetail.scss';
import SwitchStatus from 'components/Switch/Switch';
import { Status } from 'models/Status';
import LoginConfigurationContentTable from './loginConfigurationContentTable/loginConfigurationContentTable';
import { Helmet } from 'react-helmet';

const { Item: FormItem } = Form;

function LoginConfigurationDetail() {
  const [translate] = useTranslation();
  const { validAction } = crudService.useAction(
    'login-configuration',
    API_LOGIN_CONFIGURATION_ROUTE,
    'portal',
  );
  // Service goback
  const [handleGoBack] = routerService.useGoBack();

  // Hooks, useDetail, useChangeHandler
  const [
    loginConfiguration,
    setLoginConfiguration,
    loading,
    ,
    isDetail,
    handleSave,
  ] = crudService.useDetail(
    LoginConfiguration,
    loginConfigurationRepository.get,
    loginConfigurationRepository.save,
  );

  const [userStatusList] = crudService.useEnumList<Status>(
    loginConfigurationRepository.singleListStatus,
  );

  const [
    handleChangeSimpleField,
    handleChangeObjectField,
  ] = crudService.useChangeHandlers<LoginConfiguration>(
    loginConfiguration,
    setLoginConfiguration,
  );

  return (
    <>
      <Helmet>
        <meta charSet="utf-8" />
        <title>{`${loginConfiguration?.code} - eProcurement Management`}</title>
      </Helmet>
      <div className="page detail-page app-user-detail">
        <Spin spinning={loading}>
          <Card
            title={
              <div className="d-flex justify-content-between">
                <div className="d-flex justify-content-start">
                  <button
                    className="btn btn-link btn-back"
                    onClick={handleGoBack}
                  >
                    <i className="fa fa-chevron-left"></i>
                  </button>
                  <div className="pt-1 pl-1">
                    {isDetail
                      ? translate('general.detail.title')
                      : translate(generalLanguageKeys.actions.create)}
                  </div>
                </div>
                <div>
                  <button
                    className="btn btn-sm btn-outline-primary float-right ml-2 mr-2"
                    onClick={handleGoBack}
                  >
                    <i className="fa mr-2 fa-times-circle" />
                    {translate(generalLanguageKeys.actions.cancel)}
                  </button>
                  {isDetail && validAction('update') && (
                    <button
                      className="btn btn-sm btn-primary float-right"
                      onClick={handleSave}
                    >
                      <i className="fa mr-2 fa-save" />
                      {translate(generalLanguageKeys.actions.save)}
                    </button>
                  )}
                </div>
              </div>
            }
          >
            <Form>
              <Row>
                <Col lg={11}>
                  <FormItem
                    validateStatus={formService.getValidationStatus<
                      LoginConfiguration
                    >(loginConfiguration.errors, nameof(loginConfiguration.code))}
                    help={loginConfiguration.errors?.code}
                  >
                    <span className="label-input ml-3">
                      {translate('loginConfigurations.code')}
                    </span>
                    <input
                      type="text"
                      defaultValue={loginConfiguration.code}
                      className="form-control form-control-sm"
                      onChange={handleChangeSimpleField(
                        nameof(loginConfiguration.code),
                      )}
                      placeholder={translate(
                        'loginConfigurations.placeholder.code',
                      )}
                      disabled={true}
                    />
                  </FormItem>
                </Col>

                <Col lg={11}>
                  <FormItem
                    validateStatus={formService.getValidationStatus<
                      LoginConfiguration
                    >(loginConfiguration.errors, nameof(loginConfiguration.name))}
                    help={loginConfiguration.errors?.name}
                  >
                    <span className="label-input ml-3">
                      {translate('loginConfigurations.name')}
                    </span>
                    <input
                      type="text"
                      defaultValue={loginConfiguration.name}
                      className="form-control form-control-sm"
                      onChange={handleChangeSimpleField(
                        nameof(loginConfiguration.name),
                      )}
                      placeholder={translate(
                        'loginConfigurations.placeholder.name',
                      )}
                    />
                  </FormItem>
                </Col>
                <Col lg={11}>
                  <FormItem
                    validateStatus={formService.getValidationStatus<
                      LoginConfiguration
                    >(
                      loginConfiguration.errors,
                      nameof(loginConfiguration.status),
                    )}
                    help={loginConfiguration.errors?.status}
                  >
                    <span className="label-input ml-3">
                      {translate('loginConfigurations.status')}
                    </span>
                    <SwitchStatus
                      checked={
                        loginConfiguration.statusId === userStatusList[1]?.id
                      }
                      list={userStatusList}
                      onChange={handleChangeObjectField(
                        nameof(loginConfiguration.status),
                      )}
                    />
                  </FormItem>
                </Col>
              </Row>
              <Row>
                <LoginConfigurationContentTable
                  loginConfiguration={loginConfiguration}
                  setLoginConfiguration={setLoginConfiguration}
                />
              </Row>
            </Form>
          </Card>
        </Spin>
      </div>
    </>
  );
}

export default LoginConfigurationDetail;
